import React, { useEffect, useState } from 'react';

function diff(deadline) {
  const ms = new Date(deadline).getTime() - Date.now();
  if (isNaN(ms) || ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}

const pad = (n) => String(n).padStart(2, '0');

/**
 * Live countdown to a deadline (ISO string).
 * - inline: renders a compact "13d 22h 41m 09s" string (for banners on colored bg)
 * - default: renders boxed segments (for cards)
 */
export const Countdown = ({ deadline, inline = false, onExpire, className = '', testId = 'countdown' }) => {
  const [t, setT] = useState(() => diff(deadline));

  useEffect(() => {
    setT(diff(deadline));
    const id = setInterval(() => {
      const next = diff(deadline);
      setT(next);
      if (!next && onExpire) onExpire();
    }, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [deadline]);

  if (!t) return null;

  if (inline) {
    return (
      <span className={`tabular-nums font-600 ${className}`} data-testid={testId}>
        {t.days > 0 && `${t.days}d `}{pad(t.hours)}h {pad(t.minutes)}m {pad(t.seconds)}s
      </span>
    );
  }

  const seg = [
    { v: t.days, l: 'days' },
    { v: t.hours, l: 'hrs' },
    { v: t.minutes, l: 'min' },
    { v: t.seconds, l: 'sec' },
  ];
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid={testId}>
      {seg.map((s, i) => (
        <div key={s.l} className="flex flex-col items-center">
          <div className="min-w-[46px] rounded-xl px-2 py-1.5 text-center bg-[hsl(var(--surface-2))] border border-[hsl(var(--border))]">
            <span className="font-display text-xl font-700 tabular-nums text-[hsl(var(--foreground))]" data-testid={`${testId}-${s.l}`}>{pad(s.v)}</span>
          </div>
          <span className="text-[10px] mt-1 text-[hsl(var(--muted-foreground))] uppercase tracking-wide">{s.l}</span>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
